var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "20 10 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#developers_svg__filter0_d_1220_139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 50,
    height: 50,
    rx: 20,
    fill: "#154A80"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.262 22H36.155A5.155 5.155 0 0031 27.155v11.22a5.155 5.155 0 005.155 5.155h2.455c.117 0 .211.094.211.211v5.535c0 .654.8.972 1.25.495l5.806-6.175a.211.211 0 01.154-.066h7.231a5.155 5.155 0 005.155-5.155v-11.22A5.155 5.155 0 0053.262 22z",
    fill: "#EC5569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.99 41.606c0-.123-.092-.222-.205-.222h-2.377c-2.756 0-4.99-2.43-4.99-5.429V24.14c0-.508.064-.998.184-1.464A5.153 5.153 0 0031 27.155v11.22a5.155 5.155 0 005.155 5.155h2.455c.117 0 .211.095.211.212v5.534c0 .655.8.972 1.25.495l.919-.978v-7.187z",
    fill: "#E63950"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 28.69a3.351 3.351 0 00-4.74 0l-.739.739a.451.451 0 01-.638 0l-.727-.728a3.351 3.351 0 10-4.74 4.74l5.467 5.467a.452.452 0 00.639 0L50.5 33.43a3.351 3.351 0 000-4.74z",
    fill: "#EC5569"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 28.69a3.351 3.351 0 00-4.74 0l-.739.739a.451.451 0 01-.638 0l-.727-.728a3.351 3.351 0 10-4.74 4.74l5.467 5.467a.452.452 0 00.639 0L50.5 33.43a3.351 3.351 0 000-4.74z",
    fill: "#FFF5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.67 33.44a3.351 3.351 0 011.492-5.603 3.351 3.351 0 00-3.246 5.604l5.467 5.467a.451.451 0 00.639 0l.557-.557-4.91-4.91z",
    fill: "#DCE6EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "developers_svg__filter0_d_1220_139",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0 0.164706 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1220_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1220_139",
    result: "shape"
  })))));
}
export default "/_next/static/media/developers.c516f76151b552e5ac5a7a58f305d153.svg";
export { SvgDevelopers as ReactComponent };